import request from '../request.js'

// 保存/修改角色菜单信息（张卫华）
const saveOrUpdateRoleMenu = function (data) {
    return request({
        url: 'sysGroupRoleMenu/saveOrUpdate',
        method: 'post',
        data
    })
}
// 获取已选中菜单信息
const getCheckedMenu = function (data) {
    return request({
        url: 'sysGroupRoleMenu/getCheckedMenu',
        method: 'post',
        data
    })
}
// 获取预设限定菜单信息
const getLimitMenu = function (data) {
    return request({
        url: 'sysGroupRoleMenu/getLimitMenu',
        method: 'post',
        data
    })
}

export {
    saveOrUpdateRoleMenu,
    getCheckedMenu,
    getLimitMenu,
}